export const DATETIME_FORMATS = {
  common: {
    dateTime: 'd/m/Y H:i:s',
    date: 'dd/MM/yyyy',
    time: 'HH:mm',
  },
  us: {
    dateTime: 'm/d/Y H:i:s',
    date: 'MM/dd/yyyy',
    time: 'HH:mm',
  },
};
